"use strict";

/**
 * Constants(-ish) and 'environment' values.
 * Static class.
 */
export default class Constants {

  // Some tabindex values
  static TABINDEX_LESSON_PREVIOUS_BUTTON = 99;
  static TABINDEX_CONTENT_GENERAL = 100;
  static TABINDEX_CONTENT_END = 199;
  static TABINDEX_LESSON_NEXT_BUTTON = 900;
  static TABINDEX_FOOTER_PRIVACY = 997;
  static TABINDEX_FOOTER_LOGO = 999;
  static TABINDEX_FOOTER_BACK = 998;

  // TODO: Make `PathUtil` class for all path related get-functions. Also move that one fn in AppUtil.
  /**
   * The base url for all supported config files.
   * (It is required for this server to have whitelisted the Primer widget's origin.)
   */
  static get configFileBasePath() {
    // return "exampleConfigs/"
    return "https://storage.googleapis.com/p4p-config/";
  }

  static getMasterJsonPath(languageCode) {
    let suffix = Constants.getLanguageSuffixForPathing(languageCode);
    const path = `${Constants.lessonAssetsBasePath}PrimerMaster${suffix}.json`;
    return path;
  }

  /**
   * The base url for all Primer lesson data (ie, the PrimerMaster.json file
   * and all lesson files (which live in separate subdirectories per-lesson)).
   *
   * It is required for this server to have whitelisted the Primer widget's origin.
   */
  static get lessonAssetsBasePath() {
    return "https://storage.googleapis.com/primer-cms-app-data-v7/";
  }

  static getLessonJsonPath(lessonId, languageCode) {
    const subdirectory = `${lessonId}`;
    const filename = `${lessonId}${Constants.getLanguageSuffixForPathing(languageCode)}.json`;
    const path = `${Constants.lessonAssetsBasePath}${subdirectory}/${filename}`;
    return path;
  }

  /**
   * Returns a value to be inserted in the paths of various server resources for specifying correct
   * version by language.
   *
   * Used for the PrimerMaster.json file and lesson directory paths.
   */
  static getLanguageSuffixForPathing(languageCode) {
    return (languageCode === "en") ? "" : "_" + languageCode;
  }

 /**
  * Relative path where shared lesson assets are stored.
  * This is the same set of files used by the mobile apps.
  */
  static get sharedAssetsBasePath() {
    return "img/lesson_shared/";
  }

  /** Must match sass value. */
  static get cardAnimDuration() {
    return 300;
  }

  static get generalAnimDuration() {
    return 300;
  }

}
